export const servicesDataFour = [
    {
        id: '01',
        service_name: "CPR & First Aid",
        service_details: "Learn to save lives with certified medical training for all ages.",
        link: "/cpr-details",
        link_text: "Get HeartSaver Information"
    },
    {
        id: '02',
        service_name: "Self-Defense & Concealed Carry",
        service_details: "Real-world tactics from an experienced instructor.",
        link: "/ccw-details",
        link_text: "Get Self Safety Information"
    },
    {
        id: '03',
        service_name: "Safety & Security Consulting",
        service_details: "Expert advice for churches, businesses, and organizations on camera placement, exit strategies, and more.",
        link: "/contact",
        link_text: "Contact us for consulting"
    },
    {
        id: '04',
        service_name: "Custom Safety Training",
        service_details: "Tailored sessions for families, healthcare workers, Churches, and public safety teams.",
        link: "/contact",
        link_text: "Get Custom Training Quote"
    },

]